<template>

  <div class="example-item">
    <div class="scroll">
      <div id="item-container">
        <!-- 例子 -->
        <div class="example-map">
          <div class="example-title">{{itemData.header}}</div>
          <div class="example-intro">{{itemData.content}}</div>
          <div class="example-pane">
            <iframe id="example-page"
                    :src="srcData"></iframe>
          </div>
        </div>
        <!-- 代码 -->
        <div class="">
          <el-container>
            <el-main>
              <div v-for="(item,index) in codeData"
                   :key="index">
                <readCode :codeData="item"></readCode>
              </div>
            </el-main>
          </el-container>
        </div>

      </div>
    </div>

  </div>

</template>
<script>
// @ is an alias to /src
import Data from "../assets/data/data.json";
import readCode from "../components/readCode.vue";
export default {
  data() {
    return {
      editorContent: "",
      lang: "",
      leftContainerSize: 40,
      isReadOnly: false,
      itemData: [],
      srcData: "",
      codeData: [],
    };
  },
  components: {
    readCode,
  },
  methods: {},
  mounted() {
    console.log(this.$route.query);
    let data = this.$route.query;
    this.itemData = Data.example.content[data.index];
    this.srcData = "/data/example/" + data.id + "/" + data.kind + "/index.html";
    this.codeData = [
      {
        lang: "javascript",
        name: "main.js",
        url: "/data/example/" + data.id + "/" + data.kind + "/data.js",
      },
      {
        lang: "html",
        name: "index.html",
        url: "/data/example/" + data.id + "/" + data.kind + "/data.html",
      },
      {
        lang: "json",
        name: "package.json",
        url: "/data/example/" + data.id + "/" + data.kind + "/data.json",
      },
    ];
  },
};
</script>
<style lang="scss" scoped>
$handler-width: 5px;
html,
body,
.example-item {
  z-index: 1;
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
  height: calc(100vh - 65px);
  .scroll {
    overflow: auto;
    height: 100%;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      background-color: #f0f0f0;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: #66f;
    }
  }
}

::v-deep #item-container {
  .handler {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: $handler-width;
    cursor: col-resize;
    z-index: 100;
    background-color: #ccc;
    border-left: 1px solid #ececec;
    // border-right: 1px solid $clr-border;
  }
}
.button-container {
  height: 40px;
  margin: 0 auto;
  padding: 0 15px;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: white;
  border-radius: 0 0 8px 8px;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
  .el-button {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
  }
}
.el-container {
  width: 100%;
  // height: 100%;
}
.el-main {
  padding: 0;

  ::-webkit-scrollbar {
    height: 8px;
    width: 8px;
    transition: all 0.3s ease-in-out;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-button {
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    width: 8px;
    min-height: 15px;
    background: rgba(50, 50, 50, 0.6) !important;
    transition: all 0.3s ease-in-out;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5) !important;
  }
}
.editor-left-container {
  // height: 600px !important;
  position: static;
  width: 95%;
  margin: auto;
}
.example-map {
  width: 95%;
  margin: auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
  .example-title {
    font-size: 1.5rem;
    padding: 10px 0 0 15px;
    display: flex;
  }
  .example-intro {
    padding: 15px 0 0 15px;
    display: flex;
  }
  .example-pane {
    height: 600px;
    padding: 10px;
    // background-color: #fff;
    #example-page {
      height: 100%;
      width: 100%;
      border: 0px;
    }
  }
}
</style>